import {FileTypes} from '../components/shared/inputs/nx-file-upload/file-upload.model';

export const MAXIMUM_IMAGE_FILE_SIZE = 102400;
export const MAXIMUM_BATCH_FILE_SIZE = 2048000;
export const ACCEPTED_IMAGE_FILE_TYPES = [FileTypes.IMAGE_JPG, FileTypes.IMAGE_PNG];
export const ACCEPTED_DOCUMENT_FILE_TYPES = [FileTypes.APPLICATION_PDF, FileTypes.IMAGE_JPG, FileTypes.IMAGE_PNG];
